import { HttpAxiosRequest } from "./httpAxiosRequest";
import type { SecurityObjectPermission } from "../types/security";

export const HttpSecurityObjects = {
    getEndpoint: (url: string = "") => `/objetos-seguridad${url}`,

    getAll: (): Promise<SecurityObjectPermission[]> =>
        HttpAxiosRequest.get<SecurityObjectPermission[]>(HttpSecurityObjects.getEndpoint()),
};
